import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-14 md:py-20 bg-[#0d0d0d]" data-id="element-116">
      <div className="max-w-4xl mx-auto px-4" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#1a1a1a] to-[#111] p-6 md:p-10 rounded-2xl md:rounded-3xl border border-white/5 text-center relative overflow-hidden" data-id="element-118">
          <div className="absolute top-0 right-0 w-24 md:w-32 h-24 md:h-32 bg-cyan-500/10 rounded-bl-full" data-id="element-119" />

          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-cyan-900/20 rounded-full mb-4 md:mb-6 text-cyan-400" data-id="element-120">
            <ShieldCheck size={32} data-id="element-121" />
          </div>

          <h2 className="text-xl md:text-3xl font-bold text-white mb-3 md:mb-4" data-id="element-122">
            Garantía de Tranquilidad
          </h2>

          <p className="text-sm md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-123">
            Prueba el plan. Si en{' '}
            <span className="text-white font-bold" data-id="element-124">7 días</span> no notas
            ninguna mejora en tu energía o enfoque, escríbenos y te devolveremos
            tu inversión.
          </p>
        </motion.div>
      </div>
    </section>;
}